import Layout from "@/components/feature/Layout";
import AnimatedSection from "@/components/base/AnimatedSection";
import HeroSection from "./components/HeroSection";
import AboutCareerSection from "./components/AboutCareerSection";
import AboutSection from "./components/AboutSection";
import MediaSection from "./components/MediaSection";
import CasesSection from "./components/CasesSection";
import CasesBoardSection from "./components/CasesBoardSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <Layout>
      <div id="home" className="scroll-mt-20 md:scroll-mt-24">
        <HeroSection />
      </div>

      <div id="about" className="scroll-mt-20 md:scroll-mt-24">
        <AnimatedSection>
          <AboutCareerSection />
        </AnimatedSection>
        <AboutSection />
      </div>

      <div id="media" className="scroll-mt-20 md:scroll-mt-24">
        <MediaSection />
      </div>

      <div id="cases" className="scroll-mt-20 md:scroll-mt-24">
        <AnimatedSection>
          <CasesSection />
        </AnimatedSection>
      </div>

      <div id="cases-board" className="scroll-mt-20 md:scroll-mt-24">
        <CasesBoardSection />
      </div>

      <div id="contact" className="scroll-mt-20 md:scroll-mt-24">
        <ContactSection />
      </div>
    </Layout>
  );
}